import * as React from 'react';
import ConfirmationModal from 'components/Common/confirmationModal';
import './resetCycleConfirmationModal.scss';

export interface IResetCycleConfirmationModalProps {
    isModalOpen: boolean;
    closeModal: () => void;
    onResetCycleClick: () => void;
}

export class ResetCycleConfirmationModal extends React.Component<IResetCycleConfirmationModalProps> {
    constructor(props: IResetCycleConfirmationModalProps) {
        super(props);
        this._closeResetCycleModal = this._closeResetCycleModal.bind(this);
        this._resetCycleClick = this._resetCycleClick.bind(this);
    }

    render(): React.ReactNode {
        if (!this.props.isModalOpen) {
            return null;
        }

        return (
            <ConfirmationModal
                cancelMessage="Cancel"
                className="reset-cycle-modal"
                confirmMessage="Yes, Reset Cycle"
                message={this.renderResetCycleModalBody()}
                onCancel={this._closeResetCycleModal}
                onClose={this._closeResetCycleModal}
                onConfirm={this._resetCycleClick}
                title="Reset your cycle"
            />
        );
    }

    renderResetCycleModalBody(): React.ReactNode {
        return (
            <div className="reset-cycle-modal__body">
                <p>Resetting will:</p>
                <ul>
                    <li>
                        <i className="icon-check reset-cycle-modal__check" />
                        Save existing cycle settings
                    </li>
                    <li>
                        <i className="icon-check reset-cycle-modal__check" />
                        Reset all decision fields
                    </li>
                    <li>
                        <i className="icon-check reset-cycle-modal__check" />
                        Move all teams back to open
                    </li>
                    <li>
                        <i className="icon-check reset-cycle-modal__check" />
                        Allow you to preview or open the cycle
                    </li>
                </ul>
            </div>
        );
    }

    private _closeResetCycleModal(): void {
        this.props.closeModal();
    }

    private _resetCycleClick(): void {
        this._closeResetCycleModal();
        this.props.onResetCycleClick();
    }
}

export default ResetCycleConfirmationModal;